module.exports = __webpack_public_path__ + "img/pe07.6115863a.jpg";